import(/* webpackMode: "eager" */ "/actual-project/components/site-header.tsx")